var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendIconGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41683 8H3.3335V13H7.66683M19.5835 8H20.6668V13H16.3335",
    stroke: "#F7DE2A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5832 21V13H14.7082H4.4165V21H9.2915H19.5832Z",
    stroke: "#F7DE2A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.9999L12 10.5",
    stroke: "#F7DE2A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 7.99982C7.66689 7.99982 5.49954 5.5 7.12509 3.99962C8.75065 2.49923 12 4.49962 12.0001 7.99982Z",
    stroke: "#F7DE2A",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.99982C16.3331 7.99982 18.5005 5.5 16.8749 3.99962C15.2494 2.49923 12 4.49962 11.9999 7.99982Z",
    stroke: "#F7DE2A",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendIconGift);
export default __webpack_public_path__ + "static/media/friend_icon-gift.42c900593336f1f712206b4db9cff0a9.svg";
export { ForwardRef as ReactComponent };